<ng-template #ModalEditarEquipamentoLocalizacao>
  <div class="modal-content">
    <div class="modal-header u-padding-vertical-0">
      <a>Editar Localização</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <form [formGroup]="editForm" (submit)="editarEquipamentoLocalizacao()">
      <div>
        <label>Contrato</label>
        <input class="form-control" name="contrato" formControlName="contrato" readonly>

        <label>N de Série</label>
        <input class="form-control" name="numeroSerie" formControlName="numeroSerie" readonly>

        <label>Localização</label>
        <input class="form-control" name="local" formControlName="local" placeholder="Digite aqui">

        <div class="text-danger" *ngIf="editForm.get('local')?.invalid && editForm.get('local')?.touched">
          <div *ngIf="editForm.get('local')?.errors?.required">*O campo é obrigatório</div>
        </div>
      </div>

      <button type="submit" [disabled]="editForm.invalid || isButtonEnabled()" class="button-primary"> Editar
      </button>

    </form>
  </div>
</ng-template>